import { displacementBetween } from "@/utils/utilFunctions";
import Link from "next/link";
import { useEffect, useState } from "react";

type Props = {
  agency: Agency;
  provider: Provider;
  airportData: AirportNameData;
  airportCoords: {
    lat: number;
    lon: number;
  };
  locale: string;
};

const AgencyCard = ({
  locale = "en",
  agency,
  provider,
  airportData,
  airportCoords,
}: Props) => {
  // const uniqueNames = new Set<string>();
  // const filteredProviders:Provider[] = [];

  // for (const item of providers) {
  //   // Check if the name is not already in the Set
  //   if (!uniqueNames.has(item.name)) {
  //     // Add the name to the Set and push the item to the filteredProviders array
  //     uniqueNames.add(item.name);
  //     filteredProviders.push(item);
  //   }
  // }

  const [toggled, setToggled] = useState(true);
  useEffect(() => {
    setToggled(false);
  }, []);

  const displacement = displacementBetween(
    {
      lat: airportCoords.lat,
      lon: airportCoords.lon,
    },
    {
      lat: agency.pickupLocation.lat,
      lon: agency.pickupLocation.lon,
    }
  );

  const generateDisplacementString = () => {
    const displacementInMiles = displacement * 0.000621371;
    if (locale === "en") {
      if (displacementInMiles < 1) {
        return `Less than 1 Mile`;
      } else {
        return `${Math.ceil(displacementInMiles)} Mile${
          displacementInMiles < 2 ? "" : "s"
        }`;
      }
    } else {
      if (displacement < 1000) {
        return `Less than 1 km`;
      } else {
        return `${Math.ceil(displacement / 1000)} km`;
      }
    }
  };

  return (
    <div
      className={`w-full border border-[#E5EAF6] rounded-[12px] h-fit my-2 lg:my-0 cursor-pointer hover:scale-[1.01] transition-all duration-100 hover:bg-[#f4f6ff] hover:border-[#f4f6ff]`}
      onClick={() => setToggled(!toggled)}
    >
      <div className="flex items-center justify-between p-4">
        <div>
          {/* 
            FIXME: Used a static CDN URL instead of going through the process of fetching the complete URL from a request and going back and forth like crazy. This is like a quick hack...
            FIXME: If the images break, try looking at the provider icons which do have the full URL, to see if the CDN URL is still the same.
          */}
          <img
          loading="lazy"
            src={
              agency.name === "Surprise Agency"
                ? "/rental-company-list/surprise.svg"
                : `https://content.r9cdn.net/rimg/provider-logos/cars/h/${agency.icon}`
            }
            className="lg:max-w-[80px] max-w-[70px]"
            alt={`${agency.name} Logo`}
          />
        </div>
        <div className="flex flex-col w-full p-1 mx-4 lg:items-center lg:justify-between lg:flex-row">
          <div className="transition-all duration-200">
            <h4 className="lg:text-[16px] font-[500] text-[14px]">
              {agency.pickupLocation.city
                ? `Rent ${agency.name} from ${provider.name} at ${agency.pickupLocation.city}`
                : `Rent ${agency.name} from ${provider.name}`}
            </h4>
            <p
              className={`hidden lg:block text-[#334B6D] font-[400] text-[14px]`}
            >
              {`${generateDisplacementString()} Away from Airport`}
            </p>
          </div>
          <div className="lg:-mr-4">
            <button
              className="text-[#0057FF] lg:text-[12px] font-[500] text-[10px]"
              // onClick={(e)=>{
              //   e.stopPropagation();
              //   setToggled(!toggled);
              // }}
            >
              {toggled ? `Hide Address` : `Show Address`}
            </button>
          </div>
        </div>
      </div>
      {toggled && (
        <div
          className="p-4"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <p className="text-sm text-my-light-blue">
            {`${agency.name} car rentals is located ${
              agency.pickupLocation.address === undefined
                ? `in ${airportData.cityOnly}.`
                : "at"
            } ${
              agency.pickupLocation.address === undefined
                ? ""
                : `${agency.pickupLocation.address},`
            } ${
              agency.pickupLocation.city === undefined
                ? ""
                : `${agency.pickupLocation.city}, ${agency.pickupLocation.cc}.`
            } ${
              agency.pickupLocation.locType === "IN_TERMINAL" ||
              displacement === 0
                ? "It is located right inside the airport terminal and should be quick to find!"
                : agency.pickupLocation.locCategory === "AT_AIRPORT"
                ? "It is located at a walkable distance from the airport terminal, still within the airport"
                : "It seems to be located pretty far from the airport. You might want to book a cab to get there."
            }`}
          </p>
          <div className="flex items-center justify-end w-full">
            <Link
              href={`https://www.google.com/maps/dir/?api=1&destination=${agency.pickupLocation.lat},${agency.pickupLocation.lon}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#004DE3] hover:underline text-sm"
            >
              Get Directions
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default AgencyCard;
